import AsyncStorage from "@react-native-async-storage/async-storage";

const RETURN_TO_STORAGE_KEY = "axio_return_to";

const storeReturnToUrl = (url: string): void => {
  if (isValidInternalUrl(url)) {
    AsyncStorage.setItem(RETURN_TO_STORAGE_KEY, url);
    if (typeof window !== "undefined" && window.sessionStorage) {
      window.sessionStorage.setItem(RETURN_TO_STORAGE_KEY, url);
    }
  }
};

const getAndClearReturnToUrl = async (): Promise<string | null> => {
  let url = null;
  if (typeof window !== "undefined" && window.sessionStorage) {
    url = window.sessionStorage.getItem(RETURN_TO_STORAGE_KEY);
    window.sessionStorage.removeItem(RETURN_TO_STORAGE_KEY);
  }

  if (!url) {
    url = await AsyncStorage.getItem(RETURN_TO_STORAGE_KEY);
    await AsyncStorage.removeItem(RETURN_TO_STORAGE_KEY);
  }

  return url;
};

const clearReturnToUrl = async (): Promise<void> => {
  try {
    if (typeof window !== "undefined" && window.sessionStorage) {
      window.sessionStorage.removeItem(RETURN_TO_STORAGE_KEY);
    }
  } catch (_) {
    // Best-effort cleanup; ignore storage errors
  }

  try {
    await AsyncStorage.removeItem(RETURN_TO_STORAGE_KEY);
  } catch (_) {
    // Best-effort cleanup; ignore storage errors
  }
};

const isValidInternalUrl = (url: string): boolean => {
  return url.startsWith("/") && !url.startsWith("http");
};

const returnToUtils = {
  storeReturnToUrl,
  getAndClearReturnToUrl,
  clearReturnToUrl,
  isValidInternalUrl,
};

export default returnToUtils;
